































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { User } from '@/models/user';

@Component({
    name: 'Profile',
})
export default class Profile extends Vue {
    @Getter('account/userInfo') private userInfo: User;

    private isActive(route: string) {
        return this.$route.path === route ? 'is-active' : '';
    }
}
